import * as action from '../store/action-types'

function templateDataProp (key, options) {
  options = Object.assign({}, options)
  return {
    get: function () {
      const value = this.$store.getters.templateData(this.templateId)[key]
      return (value === null || value === undefined) ? options.default : value
    },
    set: function (val) {
      this.$store.dispatch(action.TEMPLATE_DATA, {
        templateId: this.templateId,
        data: {[key]: val}
      })
    }
  }
}

export default templateDataProp



// WEBPACK FOOTER //
// ./src/utils/templateDataProp.js